import { makeStyles } from '@mui/styles';
import { get } from 'lodash';
import { NumberField, NumberFieldProps, useRecordContext } from 'react-admin';

import { CurrencyField } from '@sh4res/bo-common/fields';

const useProfitLossStyles = makeStyles({
  profit: { color: 'green' },
  loss: { color: 'red' },
});

export const ProfitLossField = (props: NumberFieldProps & { testId?: string }) => {
  const record = useRecordContext(props);
  const { source, testId, ...rest } = props;

  const classes = useProfitLossStyles();

  if (!record || source === undefined) {
    return null;
  }

  return (
    <NumberField
      data-testid={testId}
      {...rest}
      source={source}
      className={record[source] >= 0 ? classes.profit : classes.loss}
    />
  );
};

export const ProfitLossCurrencyField = (props: React.ComponentProps<typeof CurrencyField>) => {
  const record = useRecordContext(props);
  const { source, testId, ...rest } = props;

  const classes = useProfitLossStyles();

  if (source === undefined) {
    return null;
  }

  const value = get(record, source);

  // 0 should be rendered
  if (value === undefined) {
    return null;
  }

  return (
    <CurrencyField
      testId={testId}
      {...rest}
      source={source}
      className={value >= 0 ? classes.profit : classes.loss}
    />
  );
};
